import {
    BetWayWin,
    isXwaysHoarder2GameData,
    SymbolValues,
    XwaysHoarder2GameData,
    XwaysHoarder2InitData
} from "./XwaysHoarder2Data";
import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {MatrixUtils} from "../utils/MatrixUtils";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {StateMatrix, StateMatrixCoordinate} from "../utils/StateMatrix";
import {SymbolStates} from "../reels/symbols/BasicSymbol";
import {SymbolUtils} from "../utils/SymbolUtils";
import {XW2GameMode, XwaysHoarder2} from "../XwaysHoarder2";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {XwaysHoarder2SymbolHeightCalculator} from "./XwaysHoarder2SymbolHeightCalculator";
import {Reel} from "../reels/Reel";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {XWaySymbol} from "../reels/symbols/XWaySymbol";
import {ScatterSymbol} from "../reels/symbols/ScatterSymbol";
import {XSplitSymbol} from "../reels/symbols/XSplitSymbol";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";


export interface WinLineData {
    betWayWin: BetWayWin,
    coordinates: StateMatrixCoordinate[],
    matrix: StateMatrix<boolean>
}

export interface WinData {
    lines: WinLineData[],
    matrix: StateMatrix<SymbolStates>
    winWays: number;
}

export interface IBetWayWinDataXW2 extends IBetWayWinData {
    length: number;
    reelWinPositions: boolean[][];
    numberOfCombinations: number;
    reelWinLvlPositions: number[][];
    winLvl: number;
    mode: string
}

export class XwaysHoarder2Model extends GameModel<XwaysHoarder2InitData, XwaysHoarder2GameData> {

    public mode: string = "";
    public nextMode: string = "";
    public isRestore: boolean = false;
    public stopReels: string[][] = [];
    public evaluatedArea: string [][] = [];
    public symbolSizesAtStart: number [][] = [];
    public symbolSizes: number [][] = [];
    public symbolValues?: SymbolValues;
    public winRatio: number = 0;
    public winData: WinData;
    public visibleReelMatrix: StateMatrix<string>;
    public featureMapKeys: number [] = [];
    public featureMap: { [key: string]: any };
    public scatterLandedPos: number[];
    public totalScatterLanded: number;
    public scatterAnticipationReels: boolean[];
    public totalWays: number;
    public reels: string[][];
    public xwayPos: PIXI.Point[] = [];
    public xwaysCountPerReel: number[];
    public xSpreadConfig: { positions: PIXI.Point [], endSizes: number [] } | undefined;
    public xSpreadPositions: PIXI.Point [] = [];
    public xsToWildPositions: PIXI.Point [] = [];
    public xnToWildPositions: PIXI.Point [] = [];
    public xnToWildInLootPositions: PIXI.Point [] = [];
    public firstXWPerReelPos: number[][] = [];
    public endSpinHeights: number[][] = [];
    public symbolscaleDirection: string[][] = [];
    public xnPresent: boolean[] = [];
    public xnToNudge: boolean[] = [];
    public xnHeight: number[] = [];
    public xwMerge: boolean[] = [];
    public reSpinTriggeredByAnotherLoot: boolean;
    public xnOrginalPos: number[] = [];
    private initReels: string[][];

    constructor(api: ApiPlugin, triggerEvents: boolean = true) {
        super(api, triggerEvents);

        XwaysHoarder2.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < XwaysHoarder2.model.initData.featureBuyTimesBetValue.length; index++) {
                if (XwaysHoarder2.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    XwaysHoarder2.buyFeatureName = betData.featureName;
                    break;
                }
            }
        });

        XwaysHoarder2.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < XwaysHoarder2.model.initData.featureBuyTimesBetValue.length; index++) {
                if (XwaysHoarder2.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    XwaysHoarder2.buyFeatureName = betData.featureName;
                    break;
                }
            }
        });
    }

    get isBigWin(): boolean {
        const activeBetFeature = XwaysHoarder2.apiPlugin.betFeatureController.getActiveBetFeature();
        let currentPlayedValue: number = 15;
        if (activeBetFeature) {
            let boosterInfo: BetFeature | undefined = XwaysHoarder2.apiPlugin.betFeatureController.getFeatureData(activeBetFeature.name);
            currentPlayedValue = this.bigwinRatiosForFeatureBuys(boosterInfo!.name) * XwaysHoarder2.model.data.playedBetValue;
            return XwaysHoarder2.model.data.totalSpinWinnings > currentPlayedValue;
        }

        let winRatio: number = MathHelper.ceilToDecimals((XwaysHoarder2.model.data.totalSpinWinnings / XwaysHoarder2.model.data.playedBetValue), 2);
        return (winRatio >= currentPlayedValue);
    }

    public get isRespinStarting(): boolean {
        return (this.mode === GameMode.NORMAL && this.nextMode === GameMode.RESPIN) || this.reSpinTriggeredByAnotherLoot;
    }

    public get isRespinEnding(): boolean {
        return this.mode === GameMode.RESPIN && (this.nextMode === GameMode.NORMAL || this.nextMode === GameMode.FREESPIN || this.nextMode === XW2GameMode.SUPER_FREESPIN);
    }

    public get isFreespinStarting(): boolean {
        return (this.mode === GameMode.NORMAL && this.nextMode === GameMode.FREESPIN) || (this.mode === GameMode.RESPIN && this.nextMode === GameMode.FREESPIN);
    }

    public get isFreespinEnding(): boolean {
        return this.mode === GameMode.FREESPIN && this.nextMode === GameMode.NORMAL;
    }

    public get isSuperFreespinStarting(): boolean {
        return (this.mode === GameMode.NORMAL && this.nextMode === XW2GameMode.SUPER_FREESPIN) || (this.mode === GameMode.RESPIN && this.nextMode === XW2GameMode.SUPER_FREESPIN);
    }

    public get isSuperFreespinEnding(): boolean {
        return this.mode === XW2GameMode.SUPER_FREESPIN && this.nextMode === GameMode.NORMAL;
    }

    public get isBaseGameRound(): boolean {
        return (this.mode === GameMode.NORMAL && this.nextMode === GameMode.NORMAL);

    }

    public get isBonusGameSpin(): boolean {
        return ((this.mode === GameMode.FREESPIN && this.nextMode === GameMode.FREESPIN) || (this.mode === XW2GameMode.SUPER_FREESPIN && this.nextMode === XW2GameMode.SUPER_FREESPIN));
    }

    public get isRespinGameSpin(): boolean {
        return (this.mode === GameMode.RESPIN && this.nextMode === GameMode.RESPIN);
    }

    public get checkRespinScenario(): boolean {
        let respinRound: boolean = false;
        if (this.mode === GameMode.RESPIN && this.nextMode === GameMode.RESPIN) {
            respinRound = true;
            if (respinRound) {
                if (XwaysHoarder2.model.gameData.reSpinTriggeredByAnotherLoot) {
                    respinRound = false;
                }
            }
        }
        return respinRound;
    }

    // to determine if presentations should be sped up
    public get isDefinitelyADeadSpin():boolean {

        const isPotentialWin = this.reels[0]
            .filter((sym) => sym != "LT" && sym != "LTX")
            .map((sym) =>
                this.reels[1].some((sym2) => [sym, "W", "XS", "XN", "XW"].indexOf(sym2) > -1) &&
                this.reels[1].some((sym2) => [sym, "W", "XS", "XN", "XW"].indexOf(sym2) > -1))
            .reduce((a, b) => a || b, false);

        return !isPotentialWin &&
               (this.mode == GameMode.NORMAL || this.mode == GameMode.RESPIN) &&
               this.nextMode == GameMode.NORMAL &&
               this.data.totalSpinWinnings == 0;
    }


    public static isEnteringMode(data: XwaysHoarder2GameData, mode: GameMode) {
        return (data.nextMode == mode && data.mode != mode);
    }

    public static isCurrentModeAndEnteringNormal(data: XwaysHoarder2GameData, mode: GameMode) {
        return (mode == data.mode && data.nextMode == GameMode.NORMAL);
    }

    public calculateGroupWinPositions(winData: IBetWayWinData): boolean[][] {
        const groupWinPositions: boolean[][] = [];
        let reelSet: String[][] = this.evaluatedArea;
        for (let reelId: number = 0; reelId < reelSet.length; reelId++) {
            groupWinPositions.push([]);
            for (let rowId: number = 0; rowId < reelSet[reelId].length; rowId++) {
                groupWinPositions[reelId].push(false);
            }
        }
        let reelWinPositions: boolean[][] = ArrayHelper.initArrayWithValues(XwaysHoarder2.model.data.reels.length, () => {
            return ArrayHelper.initArrayWithValues(XwaysHoarder2.model.data.reels.length, () => false);
        });
        for (let reelId: number = 0; reelId < winData.length; reelId++) {
            for (let rowId: number = 0; rowId < reelSet[reelId].length; rowId++) {
                if (XwaysHoarder2.model.data.mode === XW2GameMode.NORMAL) {
                    if (winData.symbol === reelSet[reelId][rowId] || reelSet[reelId][rowId].indexOf("W") > -1) {
                        groupWinPositions[reelId][rowId] = true;
                        reelWinPositions[reelId][rowId] = true;
                    }
                } else {
                    if (winData.symbol === reelSet[reelId][rowId] || reelSet[reelId][rowId].indexOf("W") > -1) {
                        groupWinPositions[reelId][rowId] = true;
                        reelWinPositions[reelId][rowId] = true;
                    }
                }
            }
        }
        winData.reelWinPositions = reelWinPositions;
        return groupWinPositions;
    }

    public createWinData(data: XwaysHoarder2GameData, visibleReelMatrix: StateMatrix<string>, evaluatedArea: StateMatrix<string>): WinData {
        const winLines: WinLineData[] = [];
        const winMatrix = new StateMatrix<SymbolStates>();
        winMatrix.initWithValueAndMatchDimensionsFromMatrix(SymbolStates.NO_WIN, visibleReelMatrix.matrix);

        let winWays = 0;
        if (isXwaysHoarder2GameData(data)) {
            for (let win of data.betWayWins) {
                winWays += win.numberOfCombinations;
                let matchingSymbols = [win.symbol, "W", "XS"];

                let skipToNextLine = false;
                /*for(let xWay of this.xWays) {
                    if(xWay.symName == win.symbol) {
                        const allSameSymbolInReel = evaluatedArea.getCoordinatesForValueInColumn(xWay.symbolPostion[0], xWay.symName);
                        if(allSameSymbolInReel.length <= 0) {
                            //There is other same symbols that connect.
                            skipToNextLine = true;
                            break;
                        }
                    }
                }*/

                if (skipToNextLine) {
                    continue;
                }

                const lineMatrix: StateMatrix<boolean> = new StateMatrix();
                lineMatrix.initWithValueAndMatchDimensionsFromMatrix(false, evaluatedArea.matrix);
                const lineData: WinLineData = {
                    betWayWin: <IBetWayWinDataXW2>win,
                    coordinates: [],
                    matrix: lineMatrix
                }

                lineData.coordinates = evaluatedArea.getAllCoordinatesWhere((value: string, column: number, row?: number) => {
                    return matchingSymbols.indexOf(value) >= 0 && column < win.length;
                });


                winMatrix.setValueForCoordinates(lineData.coordinates, SymbolStates.WIN);
                lineMatrix.setValueForCoordinates(lineData.coordinates, true);
                winLines.push(lineData);
            }
        }

        return {
            lines: winLines,
            matrix: winMatrix,
            winWays: winWays
        }
    }



    protected onInit(data: XwaysHoarder2InitData): void {
        super.onInit(data);

        this.initReels = MatrixUtils.cloneMatrix(data.reels);
        this.symbolValues = data.symbolValues;
        this.isRestore = data.isRestoreState;
        this.stopReels = MatrixUtils.cloneMatrix(data.reels);
        this.featureMap = data.featureMap || {};
        this.scatterAnticipationReels = [false, false, false, false, false];
        this.totalWays = data.totalWays;
        this.mode = data.mode;
        this.nextMode = data.nextMode;
        this.reSpinTriggeredByAnotherLoot = data.reSpinTriggeredByAnotherLoot;
        this.xwayPos = [];
        this.xwaysCountPerReel = [0, 0, 0, 0, 0, 0];
        this.xwMerge = [false, false, false, false, false, false];
        this.checkXWayPositions(data.reelsAfterCollapse);

        this.firstXWPerReelPos = [];
        this.checkFirstXWayinReel(data.reelsAfterCollapse);

        XwaysHoarder2Statics.previousReelsAfterCollapse = JSON.parse(JSON.stringify(data.reelsAfterCollapse));


    }

    protected onGame(data: XwaysHoarder2GameData): void {
        super.onGame(data);
        this.isRestore = false;
        this.mode = data.mode;
        this.nextMode = data.nextMode;
        this.reels = MatrixUtils.cloneMatrix(data.reels);
        this.stopReels = MatrixUtils.cloneMatrix(data.reels);
        this.evaluatedArea = MatrixUtils.cloneMatrix(data.evaluatedArea);

        const evaluatedArea = new StateMatrix(SymbolUtils.makeVisibleReelsMatrix(data.evaluatedArea));
        this.visibleReelMatrix = new StateMatrix(SymbolUtils.makeVisibleReelsMatrix(data.reels, 0, 0));
        //debugger;

        this.reSpinTriggeredByAnotherLoot = data.reSpinTriggeredByAnotherLoot;
        this.symbolSizes = MatrixUtils.cloneMatrix(data.symbolSizes);
        this.symbolSizesAtStart = MatrixUtils.cloneMatrix(data.symbolSizesAtStart);
        this.featureMap = data.featureMap || {};
        this.scatterLandedPos = this.parseScatterLanded(data.reels);
        this.totalScatterLanded = this.parseTotalScatters(this.scatterLandedPos);
        this.scatterAnticipationReels = this.parseScatterAnticipationReels();
        this.totalWays = data.totalWays;
        this.xwayPos = [];
        this.xwaysCountPerReel = [0, 0, 0, 0, 0, 0];
        this.xwMerge = [false, false, false, false, false, false];
        this.checkXWayPositions(this.reels);

        this.firstXWPerReelPos = [];
        this.checkFirstXWayinReel(this.reels);

        //endspinHeights is only meant to check final visual height of symbols end of spin
        //doesnt take into account old or new symbols
        this.endSpinHeights = XwaysHoarder2SymbolHeightCalculator.symbolVisualHeightCalculator();
        this.symbolscaleDirection = XwaysHoarder2SymbolHeightCalculator.scalingdirectionCalculator();

        this.winRatio = data.totalSpinWinnings / data.playedBetValue;
        this.winData = this.createWinData(data, this.visibleReelMatrix, evaluatedArea);


        this.xnPresent = [false, false, false, false, false, false];
        this.xnToNudge = [false, false, false, false, false, false];
        this.xnHeight = [0, 0, 0, 0, 0, 0];
        this.xnOrginalPos = [-1, -1, -1, -1, -1, -1];


        this.stopReels = this.calculateClientReels(this.stopReels);

        this.calculateMergeXWHappening();
        console.log("GAME DATA", data);
    }

    private bigwinRatiosForFeatureBuys(featureName: string): number {
        let ratioIntended: number;
        switch (featureName) {
            case "BOOSTED_BET_1":
                ratioIntended = 15;
                break;
            case "BOOSTED_BET_2":
                ratioIntended = 15;
                break;
            case "BOOSTED_BET_3":
                ratioIntended = 30;
                break;
            case "FREESPIN_LEVEL3":
                ratioIntended = 50;
                break;
            case "FREESPIN_LEVEL4":
                ratioIntended = 150;
                break;
            case "FREESPIN_LEVEL5":
                ratioIntended = 300;
                break;
            case "LUCKY_DRAW":
                ratioIntended = 300;
                break;
            default :
                ratioIntended = 15;
                break;
        }
        return ratioIntended;
    }

    private parseScatterLanded(currentReels: string[][]): number[] {
        let scatterPosInReels: number[] = [-1, -1, -1, -1, -1, -1];
        currentReels.forEach((reel: string[], reelNo: number) => {
            reel.forEach((symName: string, symNo) => {
                if (symName === "SC" || symName === "SSC") {
                    scatterPosInReels[reelNo] = symNo;
                }
            });
        });
        return scatterPosInReels;
    }

    private parseScatterAnticipationReels(): boolean[] {
        let anticipationReel: boolean[] = [false, false, false, false, false, false];
        if (XwaysHoarder2.model.data.mode === "FREESPIN" || XwaysHoarder2.model.data.mode === "SUPER_FREESPIN") {
            return anticipationReel;
        }
        if (XwaysHoarder2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "FREESPIN_LEVEL3" || XwaysHoarder2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "FREESPIN_LEVEL4" || XwaysHoarder2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "FREESPIN_LEVEL5") {
            return anticipationReel;
        }
        let counter: number = 0;
        let shouldCountFrom: number = 2;
        if (XwaysHoarder2.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "LUCKY_DRAW") {
            shouldCountFrom = 3;
        }
        if (this.totalScatterLanded >= 2) {
            if (XwaysHoarder2.model.mode === "NORMAL") {
                this.scatterLandedPos.forEach((item: number, index: number) => {
                    if (counter >= shouldCountFrom) {
                        anticipationReel[index] = true;
                    }
                    if (item > -1) {
                        counter++;
                    }
                });
            } else if (XwaysHoarder2.model.mode === "RESPIN") {

                XwaysHoarder2.reelView.reels.forEach((reel: Reel, reelId: number) => {
                    counter += reel.model.scatterArray.length;
                });


                this.scatterLandedPos.forEach((item: number, index: number) => {
                    if (XwaysHoarder2.reelView.reels[index].model.scatterArray.length === 0) {
                        if (counter >= shouldCountFrom) {
                            if (!this.checkifReelisFullyFilled(XwaysHoarder2Statics.previousReelsAfterCollapse[index],index)) {
                                anticipationReel[index] = true;
                            }
                        }
                        if (item > -1) {
                            counter++;
                        }
                    }
                });
            }

        }
        anticipationReel[0] = false;// additional check since SC cannot land on first reel
        // console.log("anticipation/nearwinreels", anticipationReel);
        return anticipationReel;
    }

    private checkifReelisFullyFilled(oneReel: string[],reelId:number): boolean {
        let isFilled: boolean = false;
        let count: number = 0;
        oneReel.forEach((value: string) => {
            if (value === "XW" || value === "XS") {
                count++;
            }
        });
        if (oneReel.includes("SC") || oneReel.includes("SSC")) {
            count = 0;
        }
        count === 3 ? isFilled = true : isFilled = false;
        return isFilled;
    }

    private parseTotalScatters(scatterPos: number[]): number {
        let totalScatters: number = 0;
        scatterPos.forEach((item: number) => {
            if (item > -1) {
                totalScatters++;
            }
        });
        return totalScatters;
    }

    private calculateClientReels(currentReels: string[][]): string[][] {
        let myReels: string[][] = [];
        currentReels.forEach((reel: string[], reelNo: number) => {
            myReels.push([]);
            let nudgHeightCount: number = 0;
            reel.forEach((symName: string, symNo: number) => {
                if (symName === "LTX") {
                    symName = "D";
                }
                if (symName === "XN") {
                    this.xnPresent[reelNo] = true;
                    if (nudgHeightCount === 0) {
                        this.xnOrginalPos[reelNo] = symNo;
                    } else {
                        //symName = "D";
                    }
                    nudgHeightCount++;
                }
                myReels[reelNo].push(symName);
            });
            if (this.xnPresent[reelNo]) {
                this.xnHeight[reelNo] = nudgHeightCount;
                if (nudgHeightCount < 3) {
                    this.xnToNudge[reelNo] = true;
                }
            }
        });

        myReels = this.replaceStickySymsWithDummySyms(myReels);

        return myReels;
    }

    /*    get isXWReveal():boolean{

        }*/

    private calculateMergeXWHappening(): void {
        if (this.featureMap.XW) {

            this.featureMap.XW.forEach((reel: number[], reelno: number) => {
                let crntReelHasXWMerge = false;
                let noofMergedXWValueCount: number = 0;
                reel.forEach((xwSize: number, symNo: number) => {
                    if (xwSize === 0) {
                        crntReelHasXWMerge = true;
                        noofMergedXWValueCount++;
                    }
                });
                if (noofMergedXWValueCount === 1) {
                    if ((reel[1] == 0 && reel[0] !== 0) || (reel[2] == 0 && reel[1] !== 0)) {//merged at first row position or second row position
                        XwaysHoarder2.reelView.reels[reelno].model.xwaysArray.forEach((symData: SimpleReelModelSymbolData) => {
                            const XwSym: XWaySymbol = <XWaySymbol>symData.positionable;
                            if (XwSym.symbolHeight === 2) {
                                crntReelHasXWMerge = false;
                            }
                        })
                    }

                } else if (noofMergedXWValueCount === 2) {
                    XwaysHoarder2.reelView.reels[reelno].model.xwaysArray.forEach((symData: SimpleReelModelSymbolData) => {
                        const XwSym: XWaySymbol = <XWaySymbol>symData.positionable;
                        if (XwSym.symbolHeight === 3) {
                            crntReelHasXWMerge = false;
                        }
                    })
                }
                this.xwMerge[reelno] = crntReelHasXWMerge;
            })
        } else {
            if (this.isRespinGameSpin) {
                if (!this.gameData.reSpinTriggeredByAnotherLoot) {
                    [1, 2, 3, 4].forEach((reelId) => {
                        let crntReelHasXWMerge = false;
                        if (this.xwaysCountPerReel[reelId] > 1) {
                            if (this.xwaysCountPerReel[reelId] === 2) {
                                if ((this.reels[reelId][1] === "XW" && this.reels[reelId][0] === "XW") || (this.reels[reelId][1] === "XW" && this.reels[reelId][2] === "XW")) {
                                    XwaysHoarder2.reelView.reels[reelId].model.xwaysArray.forEach((symData: SimpleReelModelSymbolData) => {
                                        const XwSym: XWaySymbol = <XWaySymbol>symData.positionable;
                                        if (XwSym.symbolHeight === 2) {
                                            crntReelHasXWMerge = false;
                                        } else {
                                            crntReelHasXWMerge = true;
                                        }
                                    })
                                }
                            } else if (this.xwaysCountPerReel[reelId] == 3) {
                                XwaysHoarder2.reelView.reels[reelId].model.xwaysArray.forEach((symData: SimpleReelModelSymbolData) => {
                                    const XwSym: XWaySymbol = <XWaySymbol>symData.positionable;
                                    if (XwSym.symbolHeight === 3) {
                                        crntReelHasXWMerge = false;
                                    } else {
                                        crntReelHasXWMerge = true;
                                    }
                                })
                            }
                            this.xwMerge[reelId] = crntReelHasXWMerge;
                        }
                    });
                }
            }
        }
    }

    private replaceStickySymsWithDummySyms(updatedReels: string[][]): string[][] {
        const newReels: string[][] = JSON.parse(JSON.stringify(updatedReels));
        XwaysHoarder2.reelView.reels.forEach((reel: Reel, reelNo: number) => {
            if (reel.model.LTarray.length > 0) {//not needed?

            }
            if (reel.model.scatterArray.length > 0) {
                reel.model.scatterArray.forEach((symData: SimpleReelModelSymbolData) => {
                    const scSym: ScatterSymbol = <ScatterSymbol>symData.positionable;
                    newReels[reelNo][scSym.symID] = "D";
                });
            }
            if (reel.model.xwaysArray.length > 0) {
                reel.model.xwaysArray.forEach((symData: SimpleReelModelSymbolData) => {
                    const xwSym: XWaySymbol = <XWaySymbol>symData.positionable;
                    newReels[reelNo][xwSym.symID] = "D";
                    if (xwSym.symbolHeight > 1) {
                        if (xwSym.symbolHeight === 2) {
                            newReels[reelNo][xwSym.symID + 1] = "D";
                        } else if (xwSym.symbolHeight === 3) {
                            newReels[reelNo][xwSym.symID + 1] = "D";
                            newReels[reelNo][xwSym.symID + 2] = "D";
                        }
                    }
                });
            }
            if (reel.model.xsplitArray.length > 0) {
                reel.model.xsplitArray.forEach((symData: SimpleReelModelSymbolData) => {
                    const xsSym: XSplitSymbol = <XSplitSymbol>symData.positionable;
                    newReels[reelNo][xsSym.symID] = "D";
                });
            }
        });

        return newReels;
    }

    private checkXWayPositions(currentReels: string[][]): void {
        currentReels.forEach((reelArray, reelId) => {
            reelArray.forEach((symName, symID) => {
                if (symName === "XW") {
                    this.xwayPos.push(new PIXI.Point(reelId, symID));
                    this.xwaysCountPerReel[reelId]++;
                }
            });
        });
    }

    private checkFirstXWayinReel(currentReels: string[][]): void {
        for (let reelID = 0; reelID < 6; reelID++) {
            for (let symID = 0; symID < 3; symID++) {
                if (currentReels[reelID][symID] === "XW") {
                    this.firstXWPerReelPos.push([reelID, symID]);
                    break;
                }
            }
        }
    }
}